import { observer } from 'mobx-react-lite';
import type { PointerEventHandler } from 'react';

import styles from './ResizablePanes.module.scss';

type Props = {
  onPointerDown: PointerEventHandler<HTMLDivElement>;
};

export const Separator = observer(function Separator({ onPointerDown }: Props) {
  return (
    <div className={styles.Separator} onPointerDown={onPointerDown}>
      <div className={styles.SeparatorLine} />
    </div>
  );
});
